import React, { SVGProps } from 'react';

interface AppIconProps extends SVGProps<SVGSVGElement> {
  name?: string;
  size?: number | string;
}

const AppIcon: React.FC<AppIconProps> = ({ name, size = 24, ...props }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <circle cx={12} cy={12} r={10} />
      <path d="M12 16v-4M12 8h.01" />
    </svg>
  );
};

export default AppIcon;
